export default "__VITE_ASSET__BgFPbzCs__"